import { combineEpics } from "redux-observable";
import { error } from "react-notification-system-redux";
import { stringify } from "query-string";
import * as fbPixel from "core/integrations/fb_pixel";
import * as dataLayer from "core/integrations/gtm";
import mixpanel from "mixpanel-browser";
import * as linkedinPixel from "core/integrations/linkedin-pixel";
import { push } from "react-router-redux";
import { history } from "core/router";
import { replaceParams } from "core/utils";
import { candidate } from "routes/paths";
import * as api from "./api";

export default combineEpics(
  action$ =>
    action$
      .ofType(api.bookTime.types.success)
      .do(() => {
        fbPixel.fbq("trackCustom", "BookingCompleted");
        dataLayer.push({
          event: "bookingComplete"
        });
        linkedinPixel.track(292537);
      })
      .map(({ payload }) =>
        push(
          `${replaceParams(candidate.pay, {
            id: payload.request.insiderId
          })}?bookingId=${payload.body.id}`
        )
      ),
  action$ =>
    action$
      .ofType(api.bookTime.types.success)
      .do(() => {
        fbPixel.fbq("trackCustom", "BookingCompleted");
        dataLayer.push({
          event: "bookingComplete"
        });
        linkedinPixel.track(292537);
      })
      .map(({ payload }) =>
        push(
          `${replaceParams(candidate.pay, {
            id: payload.request.insiderId
          })}?bookingId=${payload.body.id}`
        )
      ),
  action$ =>
    action$.ofType(api.applyPromoCode.types.success).map(({ payload }) =>
      push(
        `${replaceParams(candidate.pay, {
          id: payload.request.insiderId
        })}?bookingId=${payload.request.bookingId}&coupon=${
          payload.request.promo_code
        }`
      )
    ),
  action$ =>
    action$.ofType(api.deleteSubObjective.types.success).do(() => {
      window.location.reload();
    }),
  action$ =>
    action$
      .ofType(api.rescheduleBooking.types.success)
      .do(() => {
        fbPixel.fbq("trackCustom", "BookingRescheduled");
        dataLayer.push({
          event: "bookingRescheduled"
        });
        linkedinPixel.track(292545);
      })
      .mapTo(push(candidate.rescheduleSuccess)),
  action$ =>
    action$
      .ofType(api.cancelBooking.types.success)
      .do(() => {
        fbPixel.fbq("trackCustom", "BookingCanceled");
        dataLayer.push({
          event: "bookingCanceled"
        });
        linkedinPixel.track(292553);
      })
      .mapTo(push(candidate.cancelSuccess)),
  action$ =>
    action$
      .ofType(
        api.cancelBooking.types.failure,
        api.rescheduleBooking.types.failure
      )
      .map(({ payload }) =>
        error({
          title: payload.data.message,
          autoDismiss: 15,
          position: "br"
        })
      )
);



// WEBPACK FOOTER //
// ./src/modules/booking/epic.js